import { isValidNumber } from '@nykaa/price-filter-shared/utils';
import { ActiveFilter, ActiveFilterData, ListingFilter } from '@nykaa/listing-shared/type/filter';
import { filterTypes } from '@nykaa/listing-shared/constants/filter';


const SORT_POPULARITY = 'popularity';

export function extractActiveParamsForSearch(activeFilters: { [key: string]: ActiveFilter | string | number }) {
  const cleanedActiveParams: { [key: string]: ActiveFilter | string | number } = {};
  const parametersOfInterest = ['sort', 'q'];
  parametersOfInterest.forEach(key => {
    const keyValue = activeFilters?.[key];
    cleanedActiveParams[key] = keyValue;
  });

  return cleanedActiveParams;
}

const getPillTitle = (min: number, max: number) => {
  if (isValidNumber(min) && isValidNumber(max)) {
    return `Rs. ${min} - Rs. ${max}`;
  }
  return null;
};

export const getActiveFilterList = (activeFilters: { [key: string]: ActiveFilter | string | number }) => {
  const filterList: ActiveFilterData[] = [];
  const filterKeys = Object.keys(activeFilters) || [];
  filterKeys.forEach((parameterKey: string) => {
    if (parameterKey.indexOf('_filter') >= 1) {
      const { type, data } = (activeFilters?.[parameterKey] as ActiveFilter) || {};
      switch (type) {
        case filterTypes.SINGLE_SELECT:
          filterList.push({ id: data?.id, name: data?.name, key: parameterKey });
          break;
        case filterTypes.RANGE: {
          if (isValidNumber(data?.min) && isValidNumber(data?.max)) {
            const rangeValue = getPillTitle(data.min, data.max);
            filterList.push({ id: data?.id, name: rangeValue, key: parameterKey });
          }
          break;
        }
        default:
          if (Array.isArray(data)) {
            data.forEach(dataItem => {
              if (dataItem.id) {
                filterList.push({ id: dataItem?.id, name: dataItem?.name, key: parameterKey });
              }
            });
          }
          break;
      }
    }
  });
  return filterList;
};


export const addFilter = (
  activeFilters: { [key: string]: ActiveFilter | string | number },
  selectedFilter: ActiveFilter
) => {
  const selectedFilterKey = selectedFilter?.key || ' ';
  const activeFilterData = activeFilters?.[selectedFilterKey];
  if (typeof activeFilterData === 'string') {
    return activeFilters;
  }
  const currentFilterData = activeFilterData?.data || [];
  const { type, title } = selectedFilter || {};
  const newFilterData = selectedFilter?.data;
  switch (type) {
    case filterTypes.RANGE:
      return {
        ...activeFilters,
        [selectedFilterKey]: {
          type,
          title,
          data: newFilterData,
        },
      };
    case filterTypes.SINGLE_SELECT:
      // in case of single Select Filter we just replace the existingFilter with new data
      return {
        ...activeFilters,
        [selectedFilterKey]: {
          type,
          title,
          data: newFilterData,
        },
      };
    default:
      return {
        ...activeFilters,
        [selectedFilterKey]: {
          type,
          title,
          data: [...currentFilterData, newFilterData],
        },
      };
  }
};

export const removeSelectedFiiter = (
  activeFilters: { [key: string]: ActiveFilter | string | number },
  selectedFilter: ActiveFilterData
) => {
  const selectedFilterKey = selectedFilter?.key || ' ';
  const selectedFilterId = selectedFilter?.id || ' ';
  const activeFilterData = activeFilters?.[selectedFilterKey];
  if (typeof activeFilterData === 'string') {
    return activeFilters;
  }
  const type = activeFilterData?.type;
  const currentFilterData = activeFilterData?.data || [];
  switch (type) {
    case filterTypes.RANGE: {
      const updatedFilters = { ...activeFilters };
      delete updatedFilters[selectedFilterKey];
      return { ...updatedFilters };
    }
    case filterTypes.SINGLE_SELECT: {
      const updatedFilters = { ...activeFilters };
      delete updatedFilters[selectedFilterKey];
      return { ...updatedFilters };
    }
    default: {
      const data = currentFilterData.filter(
        (filterItem: ActiveFilterData) => selectedFilterId != filterItem.id
      );
      if (data.length > 0) {
        return {
          ...activeFilters,
          [selectedFilterKey]: {
            ...activeFilterData,
            data,
          },
        };
      }
      const updatedFilter = { ...activeFilters };
      delete updatedFilter[selectedFilterKey];
      return { ...updatedFilter };
    }
  }
};

export const handleFilterAction = (
  activeFilters: { [key: string]: ActiveFilter | string | number },
  selectedFilter: ActiveFilter | ActiveFilterData
) => {
  let isAdd = true;
  const key = selectedFilter?.key;
  const type = selectedFilter?.type;
  const selectedFilterData = selectedFilter?.data || {};
  const selectedFilterId = selectedFilterData?.id;
  const currentKeyInFilters = activeFilters[key];
  if (currentKeyInFilters) {
    if (type == filterTypes.SINGLE_SELECT) {
      if (currentKeyInFilters.data.id === selectedFilterId) {
        isAdd = false;
      }
    } else if (type == filterTypes.RANGE) {
      if ( !Array.isArray(selectedFilter) && typeof selectedFilter === 'object' && selectedFilter[currentKeyInFilters]) {
        isAdd = false;
      }
    }
    else {
      const index = currentKeyInFilters?.data?.findIndex(filter => filter.id === selectedFilterId);
      isAdd = index === -1;
    }
  }
  if (isAdd) {
    return addFilter(activeFilters, selectedFilter as ActiveFilter);
  }
  const removeFilter = { id: selectedFilterId, key: key, name: selectedFilter?.data?.name };
  return removeSelectedFiiter(activeFilters, removeFilter);
};

export const getSelectedFilterCount = (filterList: ListingFilter[], activeFilters: { [key: string]: ActiveFilter | string | number }) => {
  let count = 0;
  if (filterList && (filterList.length > 0) && activeFilters ) {
    filterList.forEach( (filterItem: ListingFilter) => {
      let tempCount = 0;
      const activeFilterKey = activeFilters?.[filterItem.key];
      if (activeFilterKey?.type === filterTypes.SINGLE_SELECT) {
        if (activeFilterKey?.data?.id && activeFilterKey?.data?.name) {
          tempCount = 1;
        }
      } else if (activeFilters[filterItem.key]?.type === filterTypes.RANGE) {
        const range = activeFilters[filterItem.key]?.data;
        if (isValidNumber(range.min) && isValidNumber(range.max)) {
          tempCount = 1;
        }
      } else {
        const newActiveData = activeFilterKey?.data?.filter((fil: any) => fil.id && fil.name);
        tempCount = newActiveData?.length || 0;
      }
      count += tempCount;
    });
  }
  return count;
};

export const hasFilterSelected = (activeFilters: ActiveFilter) => {
  if ((!activeFilters) || (typeof activeFilters !== 'object')) {
    return false;
  }
  return Object.keys(activeFilters).some((key) => key.match(/_filter$/));
};

export const hidePlpWidgets = (list: any, ids: string[], activeSort: string, activeFilters: ActiveFilter) => {
  const isFilterSelected = hasFilterSelected(activeFilters);
  if ((isFilterSelected) || (activeSort !== SORT_POPULARITY)) { // any filter selected
    return true;
  }
  //no data in widget
  return ((!list) || (list?.length === 0) || (!ids?.[0]));
};
